import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { Observable, forkJoin, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  AuctionView,
  HomePageSectionFrontendDto,
} from 'src/app/articles-manager/interfaces/auction.interface';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private readonly api = inject(ApiService);

  private readonly auctionsByLanguage = new Map<number, AuctionView[]>();
  private readonly sectionsByLanguage = new Map<
    number,
    HomePageSectionFrontendDto[]
  >();

  getAllPublic(iDLanguage: number): Observable<AuctionView[]> {
    const memoryCached = this.auctionsByLanguage.get(iDLanguage);

    if (memoryCached) {
      return of(memoryCached);
    }

    return this.api
      .requestCached<AuctionView[]>(
        ApiServiceHolder.auction.getAllPublic(iDLanguage)
      )
      .pipe(
        tap((response) => {
          this.auctionsByLanguage.set(iDLanguage, response);
        })
      );
  }

  getHomePageSections(
    iDLanguage: number
  ): Observable<HomePageSectionFrontendDto[]> {
    const memoryCached = this.sectionsByLanguage.get(iDLanguage);

    if (memoryCached) {
      return of(memoryCached);
    }

    return this.api
      .requestCached<HomePageSectionFrontendDto[]>(
        ApiServiceHolder.homePageCms.getHomePageSections(iDLanguage)
      )
      .pipe(
        tap((response) => {
          this.sectionsByLanguage.set(iDLanguage, response);
        })
      );
  }

  getHomeData(iDLanguage: number) {
    return forkJoin({
      auctionList: this.getAllPublic(iDLanguage),
      sections: this.getHomePageSections(iDLanguage),
    });
  }

  getSectionAuctions(section: HomePageSectionFrontendDto): AuctionView[] {
    return section?.auctions ?? [];
  }
}
